import PropTypes from 'prop-types';
import React from 'react';
import StyledInput from './input.style';

const Input = ({
  className = null,
  name,
  label,
  value = '',
  required = false,
  hidden = false,
  type = 'text',
  placeholder = '',
  onChange = null,
  onFocus = () => {},
  onBlur = () => {},
  active,
  warning = null,
  error = false,
  disabled = false,
  autocomplete = 'on',
  variant = 'default',
  icon = null,
  onIconClick = null,
  ...rest
}) => {
  const handleChange = e => {
    console.log({ type, min: rest.min, next: e.target.value });
    if (
      type === 'number' &&
      rest.min != null &&
      e.target.value !== '' &&
      Number(e.target.value) < Number(rest.min)
    ) {
      e.target.value = String(rest.min);
    }
    onChange?.(e);
  };

  return (
    <StyledInput
      className={className}
      error={error}
      disabled={disabled}
      active={active}
      isHidden={hidden}
      variant={variant}
    >
      <label htmlFor={label} className="input__wrapper">
        <div className="input__label">
          {required && <span className="input__required">*</span>}
          <span className="input__labelText">{label}</span>
        </div>

        <div className="input__inner">
          <input
            id={label}
            name={name}
            value={value}
            required={required}
            type={type}
            placeholder={placeholder}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={handleChange}
            aria-invalid={error}
            aria-required={required}
            disabled={disabled}
            autoComplete={autocomplete}
            {...rest}
          />
          {icon && (
            <icon className="input__icon" width="18px" height="18px" onClick={onIconClick} />
          )}
        </div>
      </label>
      {warning && (
        <span className="input__warn" aria-hidden={!error}>
          {warning}
        </span>
      )}
    </StyledInput>
  );
};

Input.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  hidden: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  active: PropTypes.bool.isRequired,
  warning: PropTypes.shape(),
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  autocomplete: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'simple']),
  icon: PropTypes.shape(),
  onIconClick: PropTypes.func
};

export default Input;
